export default __webpack_public_path__ + "static/media/folder-large-purple-3x.82c371ab.png";